import { AdditionalInfoIds } from '../models/additional-info';

export const extractAdditionalInfoIds = (source: Partial<AdditionalInfoIds>): AdditionalInfoIds => ({
	PreparationDesignBuccalId: source.PreparationDesignBuccalId,
	PreparationDesignBuccal: source.PreparationDesignBuccal,
	PreparationDesignLingualId: source.PreparationDesignLingualId,
	PreparationDesignLingual: source.PreparationDesignLingual,
	MarginDesignBuccalId: source.MarginDesignBuccalId,
	MarginDesignBuccal: source.MarginDesignBuccal,
	MarginDesignLingualId: source.MarginDesignLingualId,
	MarginDesignLingual: source.MarginDesignLingual,
	ShadeIncisal: source.ShadeIncisal,
	ShadeGingival: source.ShadeGingival,
	StumpfShade: source.StumpfShade
});
